module.exports = __webpack_public_path__ + "img/message-oto@3x.79c5a2fb.png";